import Cookies from 'universal-cookie';

export const getSession = () => {
    const cookies = new Cookies();
    return `${cookies.get('click_id')}`;
}